import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

interface IProps {
  style?: object
  label: string
  value: string
}

const Content = ({ style = {}, label, value }: IProps) => (

  <Grid container alignItems="baseline" style={{ padding: '4px 0', ...style }}>
    <Grid item xs={5}>
      <Typography variant="h4">{label}</Typography>
    </Grid>
    <Grid item xs={7}>
      {label == 'MB Type' ? (<Typography variant="body2">{value}</Typography>) : (<Typography variant="body1">{value}</Typography>)}
    </Grid>
  </Grid>
)

export default Content
